import { DashboardTileModal } from './dashboard.model';

export const publicDashboardConfig: DashboardTileModal[] = [
  {
    iconName: 'accessAamsDoc',
    tileName: 'Access AAMS Document',
    description:
      'The AAMS Document provides details about the IBC ACE AMS process, which is used by customers who need to use the IBC ACE AMS service for importing their shipments into the US',
    actionButtonTitle: 'ACCESS AAMS DOCUMENTS',
  },
  {
    iconName: 'shipmentTracking',
    tileName: 'Shipment Tracking',
    description:
      'Track your shipments easily with our Shipment Tracker, providing real-time updates and full visibility.',
    actionButtonTitle: 'TRACK SHIPMENTS',
  },
  {
    iconName: 'contactSales',
    tileName: 'Contact Sales Team',
    description:
      'Contact Sales enables customers to complete and submit a form for any assistance needed from IBC.',
    actionButtonTitle: 'CONTACT SALES',
  },
  {
    iconName: 'docs',
    tileName: 'API Documentation',
    description:
      'API Information for Shipment Tracking, Air Waybill Generation, Manifest Upload and FedEx Label Generation',
    actionButtonTitle: 'GO TO API DOCS',
  }
];

export const dashboardTileList: DashboardTileModal[] = [
  ...publicDashboardConfig,
  {
    iconName: 'trackManifest',
    tileName: 'Manifest Tracking',
    description:
      'The Manifest Tracker feature lets users easily monitor the status of their shipment clearances with real-time updates. By entering the MAWB number, you can stay up-to-date on your shipment’s progress throughout the clearance process.',
    actionButtonTitle: 'TRACK MANIFESTS',
  },
  {
    iconName: 'airWaybill',
    tileName: 'Generate Air Waybill',
    description:
      'Create Air Waybills online and manage your shipments with ease',
    actionButtonTitle: 'GENERATE AIR WAYBILL',
  },
  {
    iconName: 'uploadManifest',
    tileName: 'Manifest Upload',
    description:
      'Upload your manifest files hassle free with the Manifest Submission',
    actionButtonTitle: 'UPLOAD MANIFEST',
  },
];
